import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import ProductService from '../../services/ProductService';

const Products = () => {
  const { addListeners, showNotification, errorNotification } =
    React.useContext(AppContext);
  const [productService] = useState(new ProductService());

  const [products, setProducts] = useState([]);

  useEffect(() => {
    productService
      .GetAllProducts()
      .then((result) => {
        if (result.success) {
          setProducts(result.payload);
        } else {
          showNotification(
            'error',
            'Error while getting products',
            10,
            'Error getting products'
          );
        }
      })
      .catch((error) => {
        errorNotification(error, 'Error getting products');
      })
      .finally(() => {});
  }, []);

  useEffect(() => {
    if (products.length > 0) {
      addListeners();
      var element = document.querySelector('#portfolio-flters li');
      setTimeout(() => simulateMouseClick(element), 1000);
    }
  }, [products]);

  const mouseClickEvents = ['click'];
  function simulateMouseClick(element) {
    mouseClickEvents.forEach((mouseEventType) =>
      element.dispatchEvent(
        new MouseEvent(mouseEventType, {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        })
      )
    );
  }

  return (
    <main id="main" style={{ minHeight: '100vh' }}>
      <section className="d-flex align-items-center"></section>
      <section id="portfolio" className="portfolio">
        <div className="container">
          <div className="section-title">
            <span>Products</span>
            <h2>Products</h2>
            <p>JLAB products</p>
          </div>

          <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <ul id="portfolio-flters">
                <li data-filter="*" className="filter-active">
                  All
                </li>
              </ul>
            </div>
          </div>
          <div className="row portfolio-container">
            {products.map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6 portfolio-item">
                <img
                  src={productService.GetProductImageUrl(item.mainImage.id)}
                  className="img-fluid"
                  alt=""
                />
                <div className="portfolio-info">
                  <h4>{item.title}</h4>
                  <Link
                    to={`/products/${item.id}`}
                    className="details-link"
                    title="More Details"
                  >
                    <i className="bx bx-link"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Products;
